// NOTE(zack): SKUs in this set will hide the shipping estimate date on orders that include them.
// If you're adding to here, you should also modify the product details View to provide a disclaimer
// to the customer that the item they're ordering is a preorder.
const preorderSkus = new Set<string>([]);

export function isPreorderSku(sku: string) {
  return preorderSkus.has(sku);
}
